import OrdersIconSvg from "./orders.svg?url";
import PricingIconSvg from "./pricing.svg?url";
import ProfitIconSvg from "./profit.svg?url";
import VolumeIconSvg from "./volume.svg?url";

export const OrdersIcon = OrdersIconSvg;
export const PricingIcon = PricingIconSvg;
export const ProfitIcon = ProfitIconSvg;
export const VolumeIcon = VolumeIconSvg;